import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { useTranslation } from "react-i18next";
import { Flex } from "../../../../components/Container/Flex";
import { Secondary } from "../../../../utils/style/texts";
import TextField from "../../../../components/Controls/TextField";
import Checkbox from "../../../../components/Controls/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import ColorPicker from "../../../../components/ColorPicker";
import IconPicker from "../../../../components/IconPicker";
import BaseConfig from "../../../DashboardPage/Configs/BaseConfig";
import { Colors } from "../../../../utils/style/colors";
import { setExampleTile } from "../actions";
import { selectExampleTile } from "../selectors";

function mapDispatchToProps(dispatch) {
  return {
    setExampleTile: (d) => dispatch(setExampleTile(d)),
  };
}

const mapStateToProps = createStructuredSelector({
  exampleTile: selectExampleTile(),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ({ onAccept, setExampleTile, editConfig, tile, ...other }) => {
    const { t } = useTranslation();
    const [text, setText] = React.useState("");
    const [ribbonColor, setRibbonColor] = React.useState(Colors.gray30);
    const [bgColor, setBgColor] = React.useState(Colors.white);
    const [icon, setIcon] = React.useState("TextIcon");
    const [showIcon, setShowIcon] = React.useState(true);

    React.useEffect(() => {
      setExampleTile({
        isExample: true,
        type: "text",
        config: { text, icon, ribbonColor, bgColor, showIcon },
      });
      return () => setExampleTile();
    }, [setExampleTile, text, icon, ribbonColor, bgColor, showIcon]);

    React.useEffect(() => {
      if (editConfig) {
        setText(editConfig.text || "");
        setRibbonColor(editConfig.ribbonColor || tile.color);
        setBgColor(editConfig.bgColor || Colors.white);
        setIcon(editConfig.icon || "TextIcon");
        setShowIcon(editConfig.showIcon !== false);
      }
    }, [editConfig, tile]);

    return (
      <BaseConfig
        {...other}
        disabled={!text}
        onAccept={() =>
          onAccept({ text, icon, ribbonColor, bgColor, showIcon })
        }
      >
        <Flex col style={{ gap: 12 }}>
          <Secondary>{t("freeText.tile.description")}</Secondary>
          <TextField
            fullWidth
            label={t("text")}
            value={text}
            onChange={setText}
          />
          <ColorPicker
            label={t("backgroundColor")}
            value={bgColor}
            onChange={setBgColor}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={showIcon}
                onChange={() => setShowIcon(!showIcon)}
              />
            }
            label={t("showIcon", { defaultValue: "Show icon" })}
            labelPlacement="end"
          />
          {showIcon && (
            <>
              <ColorPicker
                label={t("ribbonColor")}
                value={ribbonColor}
                onChange={setRibbonColor}
              />
              <IconPicker label={t("icon")} value={icon} onChange={setIcon} />
            </>
          )}
        </Flex>
      </BaseConfig>
    );
  }
);
